import React, { useState, useMemo } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  TableSortLabel
} from '@mui/material';

export const TablePresentation = ({ data, dateFields=[] }) => {
  // Ensure trades is always an array
  const dataArray = data || [];

  // Dynamically extract column keys, defaulting to empty array if no trades
  const columns = useMemo(() => 
    dataArray.length > 0 ? Object.keys(dataArray[0]) : [], 
    [dataArray]
  );

  const [sortConfig, setSortConfig] = useState({
    key: columns[0] || 'default',
    direction: 'desc'
  });

  const sortedData = useMemo(() => {
    if (columns.length === 0) return [];
    return [...dataArray].sort((a, b) => {
      const key = sortConfig.key;
      if (a[key] < b[key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [dataArray, sortConfig, columns]);

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  const formatValue = (key, value) => {
    //if (key === 'created_on') return new Date(value).toLocaleString();
    if (dateFields.indexOf(key) > -1) return new Date(value).toLocaleString();
    if (key === 'success') return value ? 'Yes' : 'No';
    if (typeof value === 'number') return value.toFixed(2);
    return value;
  };

  // Return null or empty content if no columns
  if (columns.length === 0) return null;

  return (
    <TableContainer component={Paper} sx={{ width: 'auto', overflowX: 'auto' }}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column}>
                <TableSortLabel
                  active={sortConfig.key === column}
                  direction={sortConfig.key === column ? sortConfig.direction : 'asc'}
                  onClick={() => handleSort(column)}
                >
                  {column.replace(/_/g, ' ').toUpperCase()}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((col, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell 
                  key={column}
                  style={{
                    color: column === 'pl' && col[column] < 0 ? 'red' 
                         : column === 'pl' && col[column] >= 0 ? 'green' 
                         : 'inherit'
                  }}
                >
                  {formatValue(column, col[column])}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};